import React from 'react';

type ContainerProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
};

// Shared 1200-wide container. Horizontal padding scales down on narrow
// viewports via the `kc-container` class (see index.css).
export default function Container({ children, style, className }: ContainerProps) {
  const composed = ['kc-container', className].filter(Boolean).join(' ');
  return (
    <div className={composed} style={style}>
      {children}
    </div>
  );
}
